export const cmps = {
    CLIENTE: 'cliente',
    RAZON_SOCIAL: 'razonSocial',
    OBSERVACIONES: 'observaciones'
} 